import { Modal } from 'bootstrap'
function modal(id) {
    let myModal = new Modal(document.getElementById(id), {
        keyboard: false
    })
    myModal.show()
}
export { modal }